<div class="modal-header feedback-modal-header">
  <h4 class="modal-title text-white fw-semibold" id="feedback-modal-title">
    Help us improve
  </h4>
  <button type="button" class="btn btn-circle btn-sm btn-ghost element-cancel text-white" aria-label="Close modal"
    (click)="closeModal()">
  </button>
</div>

<div class="modal-body feedback-modal-body">
  <p class="mb-2 text-muted">
    Please tell us why this response wasn't helpful.
  </p>

  <!-- Thumbs Down Content -->
  <!-- Category Dropdown -->
  <div class="mb-3">
    <label for="feedback-category" class="form-label text-white">Select a category <span
        class="text-danger">*</span></label>
    <select id="feedback-category" class="form-select feedback-select" [(ngModel)]="selectedCategory"
      (change)="onCategoryChange()" [disabled]="loadingCategories || feedbackCategories.length === 0" required>
      <option value="">
        {{ loadingCategories ? '-- Loading categories...' :
        feedbackCategories.length === 0 ? '-- Categories unavailable --' :
        '-- Please select a category --' }}
      </option>
      <option *ngFor="let category of feedbackCategories" [value]="category.value">
        {{ category.label }}
      </option>
    </select>

    <!-- Show error message if categories failed to load -->
    <div *ngIf="!loadingCategories && feedbackCategories.length === 0" class="text-warning mt-1">
      <small>Unable to load categories. Please try refreshing the page.</small>
    </div>

    <!-- Show validation error for category selection -->
    <div *ngIf="showValidationError && !selectedCategory" class="text-danger mt-1">
      <small>Please select a category</small>
    </div>
  </div>

  <!-- Conditional Text Box -->
  <div *ngIf="shouldShowTextBox" class="mb-3">
    <label for="feedback-message" class="form-label text-white">
      Additional details
      <span *ngIf="isTextBoxRequired" class="text-danger">*</span>
      <span *ngIf="!isTextBoxRequired" class="text-muted">(optional)</span>
    </label>
    <textarea id="feedback-message" class="form-control feedback-textarea" rows="4" [(ngModel)]="feedbackMessage"
      (input)="onMessageChange()"
      [placeholder]="isTextBoxRequired ? 'Please provide details...' : 'Any additional details (optional)...'"
      [required]="isTextBoxRequired" maxlength="500">
      </textarea>

    <small class="text-muted">{{ feedbackMessage.length }}/500 characters</small>

  </div>

</div>

<div class="modal-footer feedback-modal-footer">
  <div class="feedback-buttons">
    <button type="button" class="btn btn-primary" (click)="submitFeedback()" [disabled]="isSubmitDisabled">
      Submit
    </button>
  </div>
</div>